/**
 * Who may read a note written about an employee (JP, 2026-10-11). Mirror of
 * the backend `EmployeeNoteVisibility`.
 * - `hr_only`: HR users with the employee notes permission (the default).
 * - `hr_and_managers`: also the employee's whole management chain, read-only
 *   in employee My team.
 * - `everyone`: also the employee themself, read-only, in the employee portal
 *   and the mobile app.
 */
export enum EmployeeNoteVisibility {
  HR_ONLY = 'hr_only',
  HR_AND_MANAGERS = 'hr_and_managers',
  EVERYONE = 'everyone',
}

/** The levels in the order a picker lists them, narrowest first. */
export const EMPLOYEE_NOTE_VISIBILITIES: readonly EmployeeNoteVisibility[] = [
  EmployeeNoteVisibility.HR_ONLY,
  EmployeeNoteVisibility.HR_AND_MANAGERS,
  EmployeeNoteVisibility.EVERYONE,
];
